
export default {
    //data
    state : {
        printing: false
    },

    //데이터 변경시
    mutations : {

    },

    //methods
    actions : {

    },

    //computed
    getters : {

    }

}